import { clsx } from 'clsx';
import React, { forwardRef } from 'react';
import classes from './Text.module.css.js';
import { toggleSxComponent } from '../internal/utils/toggleSxComponent.js';
import { jsx } from 'react/jsx-runtime';
import { useRefObjectAsForwardedRef } from '../hooks/useRefObjectAsForwardedRef.js';

const TextBaseComponent = toggleSxComponent('span');
const Text = /*#__PURE__*/forwardRef(({
  as: Component = 'span',
  className,
  size,
  weight,
  ...props
}, forwardedRef) => {
  const innerRef = React.useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  return /*#__PURE__*/jsx(TextBaseComponent, {
    as: Component,
    className: clsx(className, classes.Text),
    "data-size": size,
    "data-weight": weight,
    ...props,
    // @ts-ignore shh
    ref: innerRef
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
});
Text.displayName = 'Text';

export { Text as default };
